<!--
 * @Descripttion: 
 * @version: 
 * @Author: lzs
 * @Date: 2022-05-27 18:50:47
 * @LastEditors: Do not edit
 * @LastEditTime: 2022-05-31 16:59:52
-->
<template>
  <div class="card-box">
    <div class="header">
      <span>{{ title }}</span>
      <div class="date-box" v-if="showDateGroup">
        <span
          v-for="item in dateItem"
          :key="item.id"
          :style="activeDateId === item.id ? 'background-color: #0080ff;' : ''"
          @click="activeItem(item.id)"
          >{{ item.name }}</span
        >
      </div>
    </div>
    <div class="content" :style="`height:${height}`">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    showDateGroup: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
      default: "auto",
    },
  },
  data() {
    return {
      dateItem: [
        { name: "今日", id: 0 },
        { name: "本月", id: 1 },
        { name: "本年", id: 2 },
      ],
      activeDateId: 0,
    };
  },
  methods: {
    activeItem(id) {
      this.activeDateId = id;
    },
  },
};
</script>

<style scoped lang="scss">
.card-box {
  width: 100%;
  height: auto;
  border: 1px solid #37539d;
  background: transparent;
  box-sizing: border-box;
  &:not(:first-child) {
    margin-top: 10px;
  }
  div {
    width: 100%;
    box-sizing: border-box;
  }
  .header {
    background-color: #02225b;
    height: 42px;
    line-height: 42px;
    font-size: 16px;
    padding: 0 16px;
    text-align: left;
    display: flex;
    align-items: center;
    &::before {
      content: "";
      display: inline-block;
      width: 4px;
      height: 22px;
      background-color: #0080ff;
      margin-right: 10px;
    }
    > span {
      flex: 1;
    }
    .date-box {
      width: 56 * 3px;
      height: 30px;
      line-height: 30px;
      border: 1px solid #37539d;
      box-sizing: border-box;
      > span {
        display: inline-block;
        width: calc(100% / 3);
        text-align: center;
        box-sizing: border-box;
        font-size: 14px;
        cursor: pointer;
        &:not(:last-child) {
          border-right: 1px solid #37539d;
        }
        &:hover {
          background: #0080ff;
        }
      }
    }
  }
  .content {
    padding: 7px;
    position: relative;
  }
}
</style>
